import React from 'react';
import DownloadCsv from 'components/Button/DownloadCsv';
import {
    Flex,
    Icon,
    Select,
    Input,
    IconButton,
    InputGroup,
    InputLeftElement,
    Tooltip,
    Button,
    Box
} from '@chakra-ui/react';
import { IoMdRefresh } from 'react-icons/io';
import { CiSearch } from 'react-icons/ci';
// import { useParams, useHistory } from 'react-router-dom';
import { CONSUMER_TYPE } from 'constants/index';
import { useSearchParamsHook } from 'hooks';
import { getCurrentDate } from 'utils/date';

const FilterSearchBar = ({
    onRefresh,
    isPercentage = true,
    isDateFilter = true,
    isStatus = false,
    downloadType = CONSUMER_TYPE,
    children

}) => {
    const [searchparams , setSearchParams, cleafFilter] = useSearchParamsHook();
    const search = searchparams.get('search') || '';
    const profileProgress = searchparams.get('percentage') || '';
    const startDate = searchparams.get('startDate') || '';
    const endDate = searchparams.get('endDate') || '';
    const isSuspendedByAdmin = searchparams.get('isSuspendedByAdmin') || '';
    const curDate = getCurrentDate();
    const handleProfileChange = (value) => {
        setSearchParams('percentage', value);
    };
    const handleStatusChange = (e)=>{
        let { name, value } = e.target;
        setSearchParams(name , value);
    };
    const handleSearchChange = (value)=>{
        setSearchParams('search', value);
    };

    const handleDateChange = (e) => {
        const { name, value } = e.target;
        setSearchParams(name, value);
    };

    return (
        <Flex
            className="page-head-box"
            justify="space-between"
            align="flex-end"
            mb="4"
            gap="1"
        >
            <Flex gap={1} align="end" flexWrap="none">
                {
                    isDateFilter && <Box>
                        <Flex gap={2}>
                            <div className="date-group">
                                <label htmlFor="startDate">Start Date</label>
                                <Input
                                    min={'1999-01-01'}
                                    max={endDate || curDate}
                                    placeholder='Select start date'
                                    name='startDate'
                                    onChange={handleDateChange}
                                    value={startDate}
                                    size='sm'
                                    type='date'
                                />
                            </div>
                            <div className="date-group">
                                <label htmlFor="endDate">End Date</label>
                                <Input min={startDate} max={curDate} placeholder='Select end date' name='endDate' onChange={handleDateChange} value={endDate} size='sm' type='date' />
                            </div>
                        </Flex>
                    </Box>
                }
                {
                    isPercentage &&

                <Select
                    placeholder="Profile (in %)"
                    fontWeight="semibold"
                    size="sm"
                    w="150px"
                    onChange={(e) => handleProfileChange(e.target.value)}
                    value={profileProgress}
                >
                    <option value="10">{'>='}10%</option>
                    <option value="20">{'>='}20%</option>
                    <option value="30">{'>='}30%</option>
                    <option value="40">{'>='}40%</option>
                    <option value="50">{'>='}50%</option>
                    <option value="60">{'>='}60%</option>
                    <option value="70">{'>='}70%</option>
                    <option value="80">{'>='}80%</option>
                    <option value="90">{'>='}90%</option>
                    <option value="100">{'>='}100%</option>
                </Select>
                }
                {
                    isStatus && <Select
                        placeholder="Status (All)"
                        fontWeight="semibold"
                        size="sm"
                        w="150px"
                        name={'isSuspendedByAdmin'}
                        onChange={ handleStatusChange}
                        value={isSuspendedByAdmin}
                    >
                        <option value="true">Suspended</option>
                        <option value="false">Active</option>

                    </Select>
                }
                {children}
                <Button
                    color="red.500"
                    fontSize="sm"
                    cursor="pointer"
                    display="flex"
                    alignItems="center"
                    onClick={cleafFilter}
                    fontWeight="semibold"
                >
                    <Icon as={IoMdRefresh} boxSize={4} mr={1} />
                    <span>Reset Filter</span>
                </Button>
            </Flex>

            <Flex align="center" gap="2">

                <InputGroup maxW="350px">

                    <InputLeftElement pointerEvents="none">
                        <CiSearch color="gray.400" />
                    </InputLeftElement>
                    <Input
                        placeholder="Search"
                        size="md"
                        rounded="full"
                        value={search}
                        name='search'
                        onChange={(e) => handleSearchChange(e.target.value)}
                    />
                </InputGroup>

                <Tooltip label="Download CSV" hasArrow>
                    <IconButton
                        icon={<DownloadCsv UserType={downloadType} />}
                        color="teal.500"
                        aria-label="Download CSV"
                        size="sm"
                    />
                </Tooltip>

                <Tooltip label="Refresh Data" hasArrow>
                    <IconButton
                        icon={<IoMdRefresh />}
                        colorScheme="teal"
                        onClick={() => {
                            if (typeof onRefresh === 'function') {
                                onRefresh();
                            } else {
                                console.warn('onRefresh is not a function');
                            }
                        }}
                        aria-label="Refresh"
                        size="md"
                    />
                </Tooltip>
            </Flex>
        </Flex>
    );
};

export default FilterSearchBar;
